import {IAuthProvider, Signature, TransportLevelProvider, WampDict} from '@verkehrsministerium/kraftfahrstrasse';

export class JwtAuthProvider implements IAuthProvider {

  constructor(private authid: string) {
  }

  public ComputeChallenge(extra: WampDict): Promise<Signature> {

    const signature: Signature = {
      signature: '',
    };

    return Promise.resolve(signature);
  }

  public AuthID(): string {
    return this.authid;
  }

  public AuthMethod(): string {
    return 'jwt';
  }

  public IsTransportLevel(): boolean {
    return false;
  }
}
